import {DefaultAdapter} from './default.adapter';
import {CustomerDocument} from '../interfaces/customer-documents/customer-document';
import {inject} from '@angular/core';
import {AdapterOptions} from '../interfaces/adapter/adapter-options';
import {map} from 'rxjs/operators';
import {SyncException} from '../exceptions/sync.exception';
import {DocumentsService} from '../services/core/documents.service';

export class CustomerDocumentsAdapter extends DefaultAdapter<CustomerDocument> {

  /**
   *
   * @private
   */
  private readonly _documentsService: DocumentsService;

  /**
   *
   * @param adapterOptions
   */
  constructor(adapterOptions: AdapterOptions<CustomerDocument>) {
    super(adapterOptions);
    this._documentsService = inject(DocumentsService);
  }

  /**
   *
   * @param customerDocument
   */
  public override async save(customerDocument: CustomerDocument): Promise<CustomerDocument> {
    return this.uploadCustomerDocument(customerDocument);
  }

  /**
   *
   * @param customerDocument
   * @private
   */
  private async uploadCustomerDocument(customerDocument: CustomerDocument): Promise<CustomerDocument> {
    let blob = await this._documentsService.readDocument(customerDocument.file);
    if(typeof blob === 'string') {
      const response = await fetch(blob);
      blob = await response.blob();
    }

    const formData = new FormData();
    formData.append('customerDocument', JSON.stringify(this._toRemote(customerDocument)));
    formData.append('file', blob, customerDocument.uuid + '.pdf');

    return new Promise((resolve, reject) => {
      this._httpService.post<any>({
        url: [...this.generateUrl(customerDocument), 'upload', customerDocument.uuid],
      }, formData, {
        timeout: 20000
      }).pipe(map((_item) => {
        return this._fromObject(_item);
      })).subscribe({
        next: (_item) => {
          resolve(_item);
        },
        error: (error) => {
          console.log(error);
          const syncException = new SyncException('Unknown sync error');
          if(error?.status && error?.message) {
            syncException.code = error.status;
            syncException.message = error.message;
          }
          reject(syncException);
        }
      });
    });

  }
}